import * as React from 'react';

import { AutocompleteProps } from '@lightspeed/flame/Autocomplete';

import { createReactRenderer } from 'helpers/react-renderer';

import Autocomplete from '..';
import GuiDefHiddenInput from '../GuiDefHiddenInput';
import { createStringValueFromArray, DEFAULT_LANGUAGE, languageMap } from './utils';

const languageOptions = Object.entries(languageMap).map(([value, label]) => ({
  label,
  value,
  translate: false,
}));

const LanguagesAutocomplete: React.FC<AutocompleteProps> = ({
  isClearable = true,
  placeholder = 'Select language(s)',
  hiddenInput,
  ...rest
}) => {
  const [value, setValue] = React.useState<AutocompleteOption[]>([]);

  React.useEffect(() => {
    const { printedDocumentLanguages = [DEFAULT_LANGUAGE] } = window.merchantos.options;

    let options = printedDocumentLanguages
      .map((language) => languageOptions.find(({ value }) => language === value)!)
      .filter(Boolean);

    if (!options.length) {
      options = [languageOptions[0]];
    }

    setValue(options);
  }, []);

  return (
    <>
      <Autocomplete
        aria-label="languages-autocomplete-input"
        {...rest}
        value={value}
        closeMenuOnSelect={false}
        options={languageOptions}
        placeholder={placeholder}
        isMulti
        isClearable={isClearable}
        onChange={setValue}
        components={{
          DropdownIndicator: () => null,
        }}
      />

      {hiddenInput ? (
        // @ts-ignore
        <GuiDefHiddenInput {...hiddenInput} defaultValue={createStringValueFromArray(value)} />
      ) : null}
    </>
  );
};

const RenderedComponent = createReactRenderer({
  component: LanguagesAutocomplete,
  selector: '[data-react-root="LanguagesAutocomplete"]',
});

export default LanguagesAutocomplete;

history.onChangeState(
  [
    {
      name: ['admin.views.options'],
      form_name: 'view',
      tab: ['settings', 'printing'],
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
